const HOUR = 3_600_000;
/**
 * Half an hour either side of a plate belongs to that plate, symmetrically: an hour and a
 * half before high water is the HW−2 plate, as an hour and a half after it is HW+2.
 * JavaScript's own rounding breaks that symmetry for negative halves (−1.5 becomes −1).
 */
function roundHalfAway(x) {
    return x < 0 ? -Math.round(-x) : Math.round(x);
}
/**
 * Which plate shows the stream at this moment, following the old app
 * (`TExtrema.StroomkaartNr`, `obj_Extrema.pas:614`): count back from the *next* high water,
 * and when that lands before HW−6, count forward from the previous one instead. A tide is
 * 12h25m, so both together cover every moment, and the half hour that rounds to ±6 is the
 * slack in the middle.
 */
export function atlasPlate(extrema, time) {
    const hws = extrema.filter(e => e.type === 'HW').map(e => e.time).sort((a, b) => a - b);
    if (!hws.length)
        return null;
    const next = hws.find(t => t >= time);
    const previous = [...hws].reverse().find(t => t < time);
    let hw = next ?? previous;
    let hour = roundHalfAway((time - hw) / HOUR);
    if (hour < -6 && previous !== undefined) {
        hw = previous;
        hour = roundHalfAway((time - hw) / HOUR);
    }
    // beyond the ends of the atlas the nearest plate is the best there is
    hour = Math.max(-6, Math.min(6, hour));
    return { hour, time: hw + hour * HOUR, hw };
}
/** The plate's file name: HW has no number, the rest count minus and plus */
export function plateName(hour) {
    return hour === 0 ? 'hw' : hour > 0 ? `p${hour}` : `m${-hour}`;
}
//# sourceMappingURL=atlas.js.map